import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import NavigationHeader from '../../components/NavigationHeader';
import SectionScrollIndicator from '../../components/SectionScrollIndicator';
import HeroSection from './components/HeroSection';
import SkillsPreview from './components/SkillsPreview';
import FeaturedProjects from './components/FeaturedProjects';
import ExperienceHighlight from './components/ExperienceHighlight';
import CallToAction from './components/CallToAction';

const HomeLandingPage = () => {
  useEffect(() => {
    // Smooth scroll to top on page load
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Set page title
    document.title = 'Dishant Madariya - Full Stack Developer | DevPortfolio';
  }, []);

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>Dishant Madariya - Full Stack Developer | React, Node.js, Cloud Solutions</title>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content="Full Stack Developer Dishant Madariya specializing in React, Node.js, and cloud architecture. Building scalable web applications with modern technologies. View portfolio, projects, and get in touch for web development opportunities."
        />
        <meta
          name="keywords"
          content="Dishant Madariya, full stack developer, React developer, Node.js developer, cloud architecture, web development, JavaScript, TypeScript, portfolio, software engineer, frontend developer, backend developer"
        />
        <meta name="author" content="Dishant Madariya" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="7 days" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://port-folio-three-teal.vercel.app/" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://port-folio-three-teal.vercel.app/" />
        <meta property="og:title" content="Dishant Madariya - Full Stack Developer | React & Node.js Expert" />
        <meta property="og:description" content="Experienced Full Stack Developer specializing in React, Node.js, and cloud solutions. Explore my portfolio showcasing scalable web applications and innovative projects." />
        <meta property="og:image" content="https://port-folio-three-teal.vercel.app/images/dishant-portfolio-preview.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Dishant Madariya - Full Stack Developer Portfolio" />
        <meta property="og:site_name" content="Dishant Madariya Portfolio" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@dishant_patel14" />
        <meta name="twitter:creator" content="@dishant_patel14" />
        <meta name="twitter:title" content="Dishant Madariya - Full Stack Developer | React & Node.js" />
        <meta name="twitter:description" content="Full Stack Developer creating scalable web applications with React, Node.js, and cloud technologies. View portfolio and projects." />
        <meta name="twitter:image" content="https://x.com/dishant_patel14/photo" />
        <meta name="twitter:image:alt" content="Dishant Madariya Portfolio Preview" />

        {/* LinkedIn Specific */}
        <meta property="og:type" content="profile" />
        <meta property="profile:first_name" content="Dishant" />
        <meta property="profile:last_name" content="Madariya" />
        <meta property="profile:username" content="dishantmadariya" />

        {/* Additional SEO Meta Tags */}
        <meta name="theme-color" content="#000000" />
        <meta name="msapplication-TileColor" content="#000000" />
        <meta name="application-name" content="Dishant Madariya Portfolio" />

        {/* Favicon */}
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

        {/* DNS Prefetch */}
        <link rel="dns-prefetch" href="//fonts.googleapis.com" />
        <link rel="dns-prefetch" href="//github.com" />
        <link rel="dns-prefetch" href="//linkedin.com" />

        {/* Social Media Profiles */}
        <meta property="og:see_also" content="https://linkedin.com/in/dishantmadariya" />
        <meta property="og:see_also" content="https://github.com/DishantMadariya" />
        <meta name="twitter:creator" content="@dishant_patel14" />

        {/* Additional Profile Links */}
        <link rel="me" href="https://linkedin.com/in/dishantmadariya" />
        <link rel="me" href="https://github.com/DishantMadariya" />

      </Helmet>


      <div className="min-h-screen bg-background">
        <SectionScrollIndicator />

        <main className="pt-16">
          <HeroSection />
          <SkillsPreview />
          <FeaturedProjects />
          <ExperienceHighlight />
          <CallToAction />
        </main>
      </div>
    </>
  );
};

export default HomeLandingPage;